import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class About extends Vue {
   public title: string = 'About RIFO Hybrid (Web Side)';

   public onContactButtonClick() {
    window.open('http://rifo.ca');
    // this.$router.push('http://rifo.ca');
   }

   get count() {
      return this.$store.state.count;
   }

   public increase() {
      this.$store.commit('increment');
   }

}
